import { useEcheances } from '@/hooks';
import TileEcheances from '../tiles/TileEcheances';

/**
 * Conteneur smart pour TileEcheances
 * Utilise le hook useEcheances pour calculer les prochaines échéances
 */
const TileEcheancesContainer = () => {
  const { echeanceArrete, echeanceVersement } = useEcheances();

  return <TileEcheances echeanceArrete={echeanceArrete} echeanceVersement={echeanceVersement} />;
};

export default TileEcheancesContainer;
